import React, { useCallback, useEffect } from 'react'

type ArcadeEmbedProps = {
  url: string
  title: string
  onArcadeStarted?: () => void
}

export const ArcadeEmbed: React.FC<ArcadeEmbedProps> = ({ onArcadeStarted, url, title }) => {
  const onReceiveMessage = useCallback(
    (message: MessageEvent) => {
      if (message.origin !== 'https://demo.arcade.software') {
        return
      }

      if (message.data.eventName === 'Overlay Clicked') {
        typeof onArcadeStarted === 'function' && onArcadeStarted()
      }
    },
    [onArcadeStarted],
  )

  useEffect(function () {
    window.addEventListener('message', onReceiveMessage)

    return function () {
      window.removeEventListener('message', onReceiveMessage)
    }
  })

  return (
    <div style={{ position: 'relative', paddingBottom: 'calc(56.59863945578232% + 41px)', height: 0, width: '100%' }}>
      <iframe
        src={url}
        title={title}
        frameBorder='0'
        loading='lazy'
        allowFullScreen
        allow='clipboard-write'
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', colorScheme: 'light' }}
      />
    </div>
  )
}
